import { request } from '@/utils'

export default {
  getEmptyCustomer: () => {
    return {
      customerOrgId: null,
      profileV2DTO: [
        {
          attachmentIdList: [],
          attachmentList: [],
          birthdayDate: null,
          birthdayDateType: null,
          branchedPassageCode: null,
          customerContactList: [
            {
              mobile: null,
              phone: null,
            },
          ],
          customerOrgDeptId: null,
          customerOrgId: null,
          decisionRelationCodes: [],
          followStatusCode: null,
          id: null,
          jobPosition: null,
          jobPositionLevelCode: null,
          name: null,
          orgAddDTO: {
            address: null,
            city: null,
            cityName: null,
            country: null,
            customerId: null,
            id: null,
            latitude: null,
            longitude: null,
            province: null,
            provinceName: null,
            region: null,
            regionName: null,
          },
          qq: null,
          sex: null,
          email: null,
          summary: null,
          weixin: null,
          teamWorkerIdList: [],
        },
      ],
      teamWorkerIdList: [],
    }
  },
  getEmptyCustomerCompany: () => {
    return {
      classificateCode: null,
      id: null,
      industryCodes: null,
      name: null,
      natureCodes: [],
      parentId: null,
      shortName: null,
      sourceCode: null,
      summary: null,
      typeCode: null,
      orgAddDTO: {
        address: null,
        city: null,
        cityName: null,
        country: null,
        customerId: null,
        id: null,
        latitude: null,
        longitude: null,
        province: null,
        provinceName: null,
        region: null,
        regionName: null,
      },
    }
  },
  getEmptyQuery: () => {
    return {
      createUser: null,
      deptIds: null,
      keyWord: null,
      orgId: null,
      sortName: null,
      sortOrder: null,
      decisionRelationCodes: null,
      jobPositionLevelCode: null,
      source: null,
      customerLevel: null,
      followStatusCode: null,
      followStatus: null,
    }
  },
  getCompanyEmptyQuery: () => {
    return {
      createUser: null,
      classificateCode: null,
      keyWord: null,
      natureCode: null,
      proCityRegionCode: null,
      sourceCode: null,
      sortName: null,
      sortOrder: null,
    }
  },
  getCustomerByPage: (params: PageParams) => {
    return request.post(`/project/customer/profile/pageList?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`, params.body || {})
  },
  getCustomerById: (id: string) => request.get(`/project/customer/profile/getDetail/${id}`),
  saveCustomer: (data: Recordable) => request.post('/project/customer/profile/saveProfile', data),
  updateCustomer: (data: Recordable) => request.put('/project/customer/profile/editProfile', data),
  exportCustomers: (data: Recordable) => request.post('/project/customer/profile/export', data, { responseType: 'blob' }),
  getCustomerAll: () => request.get('/project/customer/profile/findAll'),
  getDeptList: (id: string) => request.post(`/project/project/open/list/${id}`),
  getCustomerOrgSource: () => request.get('/system/diction/findByCode/customer_org_source_code'),
  getCustomerOrgIndustry: () => request.get('/system/diction/findByCode/customer_org_industry_code'),
  getCustomerOrgType: () => request.get('/system/diction/findByCode/customer_org_type_code'),
  getCustomerOrgNature: () => request.get('/system/diction/findByCode/customer_org_nature_code'),
  getCustomerOrgClassificate: () => request.get('/system/diction/findByCode/customer_org_classificate_code'),
  getCustomerOrgRelation: () => request.get('/system/diction/findByCode/customer_decision_relation_code'),
  getCustomerOrgLevel: () => request.get('/system/diction/findByCode/customer_job_position_level_code'),
  getCustomerOrgStatus: () => request.get('/system/diction/findByCode/customer_follow_status_code'),
  getChinaProvinceCityRegion: () => request.get('/system/system/open/getChinaProvinceCityRegion'),
  getSelectUser: (data: any) => request.post('/system/system/open/getSelectUser', data),
  addCustomerDept: (data: any) => request.post('/project/customer/customerOrgDepartment/saveAuto', data),

  getCustomerCompanyByPage: (params: PageParams) => {
    return request.post(`/project/customer/org/pageList?pageSize=${params.pageSize}&pageNumber=${params.pageNumber}`, params.body || {})
  },
  getCustomerCompanyById: (id: string) => request.get(`/project/customer/org/getById/${id}`),
  saveCustomerCompany: (data: Recordable) => request.post('/project/customer/org/save', data),
  updateCustomerCompany: (data: Recordable) => request.put('/project/customer/org/update', data),
  exportCustomerCompanys: (data: Recordable) => request.post('/project/customer/org/export', data, { responseType: 'blob' }),
  getCustomerCompanyAll: () => request.get('/project/customer/org/queryOrg'),
  getSelectUserWithLeave: () => request.post('/system/system/open/getSelectUserWithLeave'),

  dupCustomerMobile: (mobile: string) => request.get(`/project/customer/profile/queryContactByMobile/${mobile}`),
  dupCustomerPhone: (phone: string) => request.get(`/project/customer/profile/queryContactByPhone/${phone}`),
  getCompanyNameByName: (name: string) => request.get(`/project/customer/profile/queryCompanyName/${name}`),
  getAllCompany: () => request.get('/project/customer/profile/queryCompanyNameList'),
  getDictByCode: (code: string) => request.get(`/system/diction/findByCode/${code}`),
  checkOrgName: (id: string, orgName: string) =>
    request.get(`/project/customer/org/checkOrgName?orgName=${orgName}${id ? `&id=${id}` : ''}`),
  loadOrgNameByNameLike: (orgName: string) => request.get(`/project/customer/org/orgAssociate?orgName=${orgName}`),
  delOrg: (customerId: any) => request.post(`/project/customer/org/delOrg?id=${customerId}`),
  getHistoryModifyRecordDetail: (id: string) => request.get(`/project/customer/profile/getHistoryModifyRecordDetail?historyId=${id}`),
  getHistoryCustomerModifyRecordList: (customerId: string) =>
    request.get(`/project/customer/profile/getHistoryCustomerModifyRecordList?customerId=${customerId}`),
}
